// extracted by mini-css-extract-plugin
export default {"container":"EmailShare_container__ur7mu","shareEmailBtn":"EmailShare_shareEmailBtn__4g7Um","emailSvg":"EmailShare_emailSvg__Ww194"};